import { getUUIDv4 } from '@js/common/utils'

void (function () {
  const quizWidgetElement = document.querySelector('.js-quiz-widget')
  if (!quizWidgetElement) return

  const flow_id = getUUIDv4()

  /* Attach flow id to all question options */
  const questionLinks = document.querySelectorAll('.js-quiz-option')
  for (const link of questionLinks) {
    link.href =
      link.href + ((link.href.indexOf('#') > 0 ? '&fi=' : '#fi=') + flow_id)

    link.addEventListener('click', function (event) {
      const target = event.currentTarget

      if (
        target.href &&
        !(event.ctrlKey || event.metaKey || event.shiftKey) &&
        target.target !== '_blank'
      ) {
        window.location = target.href
      }

      if (
        target.href &&
        (event.ctrlKey ||
          event.metaKey ||
          event.shiftKey ||
          target.target === '_blank')
      ) {
        return
      }

      event.preventDefault()
    })
  }
})()
